module.exports = __webpack_public_path__ + "img/arrival_9.071a3477.jpg";